import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ShiftService } from '../services/shift.service';
import { Shift } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class ShiftResolverService {

    constructor(
        private shiftService: ShiftService,
        private router: Router
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Shift> {
        const id = route.paramMap.get('id');

        if (id === null) {
            return of(new Shift());
        }

        return this.shiftService.get(+id).pipe(
            map(shift => {
                if (shift) {
                    return shift;
                }
                this.router.navigate(['/shift/schedule']);
                return null;
            })
        );
    }
}
